<template>
    <div>
        <div class="title">Uzyskaj numer paszportu Instalatora</div>
        <transition name="fade" mode="out-in" appear>
            <div class="message has-icon is-success" v-if="isSuccess" key="success">
                <div class="message-body has-text-weight-semibold">
                <span class="icon"><i class="far fa-smile"></i></span>
                    <p class="subtitle">Dziękujemy za przesłanie formularza!</p>
                    <p>Zanim przystąpimy do weryfikacji Twojego zgłoszenia niezbędne będzie potwierdzenie rejestracji poprzez kliknięcie w link, który wysłaliśmy do Ciebie na Twój adres e-mail.</p>
                </div>
            </div>
            <div class="message has-icon is-danger" v-if="isError" key="error">
                <div class="message-body has-text-weight-semibold">
                <span class="icon"><i class="far fa-exclamation-triangle"></i></span>
                    <p>{{ errorMsg }}</p>
                </div>
            </div>
        </transition>

        <form @submit.prevent="register()" :class="{'is-loading' : isLoading}" v-if="showForm">
            <fieldset>
                <div class="subtitle">Twoje dane</div>
                
                <div class="columns is-tablet">
                    <div class="column">
                        <validated-field label="Imię" :validation="validation.firstName">
                            <input type="text" class="input" v-model="form.firstName">
                        </validated-field>
                    </div>
                    <div class="column">
                        <validated-field label="Nazwisko" :validation="validation.lastName">
                            <input type="text" class="input" v-model="form.lastName">
                        </validated-field>
                    </div>
                </div>

                <validated-field label="E-mail" :validation="validation.email">
                    <input type="email" class="input" v-model="form.email">
                </validated-field>

                <validated-field label="Numer telefonu komórkowego" :validation="validation.phone">
                    <input type="tel" class="input" v-model="form.phone" v-mask="'###-###-###'">
                </validated-field>
            </fieldset>

            <fieldset class="has-margin-top">
                <div class="subtitle">Dane firmy</div>

                <div class="message has-icon">
                    <div class="message-body has-text-weight-semibold">
                    <span class="icon"><i class="far fa-info-circle"></i></span>
                    <p>Podaj tylko NIP firmy. Wszystkie niezbędne dane pobierzemy z publicznych rejestrów. Jeśli dane nie będą kompletne, poprosimy Cię o ręczne ich uzupełnienie.</p>
                </div>
                </div>

                <validated-field label="NIP" :validation="validation.companyNIP">
                    <input type="tel" class="input" v-model="form.companyNIP" v-mask="'##########'">
                </validated-field>

                <validated-field label="Nazwa" :validation="validation.companyName" v-if="showCompanyAddressFields">
                    <input type="text" class="input" v-model="form.companyName">
                </validated-field>

                <validated-field label="E-mail" :validation="validation.companyEmail">
                    <input type="email" class="input" v-model="form.companyEmail">
                </validated-field>

                <div class="columns is-tablet" v-if="showCompanyAddressFields">
                    <div class="column is-3-tablet">
                        <validated-field label="Kod" :validation="validation.companyZipcode">
                            <input type="tel" class="input" v-model="form.companyZipcode" v-mask="'##-###'">
                        </validated-field>
                    </div>
                    <div class="column">
                        <validated-field label="Miejscowość" :validation="validation.companyTown">
                            <input type="text" class="input" v-model="form.companyTown">
                        </validated-field>
                    </div>
                </div>

                <validated-field label="Ulica wraz z numerem domu/lokalu" :validation="validation.companyStreet" v-if="showCompanyAddressFields">
                    <input type="text" class="input" v-model="form.companyStreet">
                </validated-field>

                <div class="field">
                <div class="checkbox is-dark is-horizontal">
                    <input type="checkbox" class="styled" id="gdpr" v-model="form.gdprTerms">
                    <label for="gdpr"><span>Oświadczam, że akceptuję warunki przetwarzania moich danych osobowych.</span></label>
                </div>

                </div>
            </fieldset>

            <button type="submit" :disabled="!form.gdprTerms" class="button is-fullwidth is-medium is-dark has-margin-top less">{{ buttonCaption }}</button>
            <div class="has-text-centered has-margin-top less">
                <a class="is-size-6 has-text-dark" @click="showGDPR = true">Pokaż treść obowiązku informacyjnego RODO</a>
            </div>
        </form>

        
        <modal v-if="showGDPR" :onClose="() => showGDPR = false"><GDPR/></modal>

    </div>
</template>

<script>
export default {
    components: {
        ValidatedField: () => import("@/components/forms/ValidatedField.vue"),
        GDPR: () => import("@/components/GDPR")
    },
    computed: {
        buttonCaption() {
            return this.form.gdprTerms ? 'Zarejestruj się' : 'Zaakceptuj warunki korzystania';
        },
        showCompanyAddressFields() {
            return this.validation.show_address_fields != null;
        }
    },
    data() {
        return {
            isLoading: false,
            showForm: true,
            isSuccess: false,
            isError: false,
            errorMsg: null,
            validation: {},
            showGDPR: false,
            form: {
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                
                companyNIP: '',
                companyName: '',
                companyStreet: '',
                companyZipcode: '',
                companyTown: '',
                companyEmail: '',
                gdprTerms: false
            }
        }
    },
    methods: {
        register() {
            this.isLoading = true;
            this.isError = false;
            this.validation = {};
            this.axios.post("/registerForPassportNumber", 
                this.form 
            )
            .then(() => {
                this.isSuccess = true;
                this.showForm = false;
            })
            .catch((error) => {
                if(error.response.data.validation) {
                    this.validation = error.response.data.validation;
                }
                if(error.response.data.message) {
                    this.isError = true;
                    this.errorMsg = error.response.data.message;
                }
            })
            .finally(() => {
                this.isLoading = false;
            })
        },
        registerFake() {
            this.isLoading = true;
            this.isError = false;
            this.validation = {};

            setTimeout(() => {
                this.isSuccess = true;
                this.showForm = false;
                this.isLoading = false;
            }, 1000)
        }
    }
}
</script>